<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="dr_vendname,pr_detail,dr_remark"
      placeholder="输入供应商、物料、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'PurchaseDeliveryReminder', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.dr_vendname}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.dr_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.dr_is_end==0}"
          >{{item.isEnd ? "关闭" : "开启"}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_total')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/deliveryReminder/list",
      filters: [
        {
          type: "date",
          name: "dr_date"
        },
        // {
        //   type: "condition",
        //   label: "状态",
        //   value: -1,
        //   options: [
        //     {
        //       value: -1,
        //       label: "全部",
        //       condition: "pi_class='SALERETURN'"
        //     },
        //     {
        //       value: 1,
        //       label: "待退货",
        //       condition:
        //         "pi_class='SALERETURN' and ifnull(pi_status,' ')<>'已审核'"
        //     },
        //     {
        //       value: 2,
        //       label: "已退货",
        //       condition:
        //         "pi_class='SALERETURN' and ifnull(pi_status,' ')='已审核'"
        //     }
        //   ]
        // }
      ]
    };
  }
};
</script>